import React, { useEffect, useState } from "react";
import { addSettlementAccount } from "../api/settalmentApi";
import { dmtBanks } from "../json-data/dmtbanklist";
import { useNotify } from "../context/NotifyContext";
import useBankVerification from "../hooks/useBankVerification";
import BankVerificationBox from "./BankVerificationBox";

const AddBank = ({ open, close }) => {
  const { notify } = useNotify();

  const [holderName, setHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccount, setConfirmAccount] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [remarks, setRemarks] = useState("");
  const [upiId, setUpiId] = useState("");
  const [chequeFile, setChequeFile] = useState(null);
  const [qrCodeFile, setQrCodeFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [allBanks, setAllBanks] = useState([]);
  const [bankId, setBankId] = useState("");
  const [bankName, setBankName] = useState("");

  // const bankVerification = useBankVerification({
  //   accountNumber,
  //   ifsc,
  //   name: holderName,
  //   bankId,
  //   bankName,
  //   sourceType: "SETTLEMENT",
  //   onVerified: (result) => {
  //     if (result.beneficiaryName && !holderName) {
  //       setHolderName(result.beneficiaryName);
  //     }
  //   },
  // });

  const bankVerification = useBankVerification({
  accountNumber,
  ifsc,
  name: holderName,
  bankId,
  bankName,
  sourceType: "SETTLEMENT",
  onVerified: (result) => {
    if (result?.beneficiaryName) {
      setHolderName(result.beneficiaryName);
    }
  },
});

  useEffect(() => {
    if (dmtBanks?.length) {
      setAllBanks(dmtBanks);
    }
  }, []);

  const handleBankChange = (e) => {
    const selectedBankId = e.target.value;
    const selectedBank = allBanks.find(
      (bank) => Number(bank.BankId) === Number(selectedBankId)
    );

    setBankId(selectedBankId);
    setBankName(selectedBank?.BankName || "");
  };

  const resetForm = () => {
    setHolderName("");
    setAccountNumber("");
    setConfirmAccount("");
    setIfsc("");
    setRemarks("");
    setUpiId("");
    setChequeFile(null);
    setQrCodeFile(null);
    setBankId("");
    setBankName("");
  };

  const handleClose = () => {
    if (loading) return;
    resetForm();
    close();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setChequeFile(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanHolderName = holderName.trim();
    const cleanAccountNumber = accountNumber.trim();
    const cleanConfirmAccount = confirmAccount.trim();
    const cleanIfsc = ifsc.trim().toUpperCase();
    const cleanRemarks = remarks.trim();
    const cleanUpiId = upiId.trim();

    if (!cleanHolderName) {
      return notify("Account Holder Name is required", "warning");
    }

    if (!cleanAccountNumber) {
      return notify("Account Number is required", "warning");
    }

    if (!cleanConfirmAccount) {
      return notify("Confirm Account Number is required", "warning");
    }

    if (!cleanIfsc) {
      return notify("IFSC Code is required", "warning");
    }

      

    if (!bankId) {
      return notify("Bank must be selected", "warning");
    }

    if (cleanAccountNumber !== cleanConfirmAccount) {
      return notify("Account numbers must match", "error");
    }

    if (!/^\d{9,18}$/.test(cleanAccountNumber)) {
      return notify("Account number must be 9-18 digits", "warning");
    }

    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(cleanIfsc)) {
      return notify("Invalid IFSC format", "error");
    }

    // Compulsory check: If verification required and not verified yet
    if (bankVerification.verificationRequired && !bankVerification.ready) {
      return notify(
        "Please verify this bank account before adding",
        "warning"
      );
    }

    // UPI is optional. Validate only when user enters it.
    if (cleanUpiId && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+$/.test(cleanUpiId)) {
      return notify("Invalid UPI ID", "error");
    }

    if (!cleanUpiId && !qrCodeFile) {
      return notify("Configure at least a UPI ID or upload a QR Code", "error");
    }

    const fd = new FormData();
    fd.append("accountHolderName", cleanHolderName);
    fd.append("accountNumber", cleanAccountNumber);
    fd.append("confirmAccountNumber", cleanConfirmAccount);
    fd.append("ifsc", cleanIfsc);
    fd.append("remarks", cleanRemarks);
    fd.append("bankId", bankId);
    fd.append("bankName", bankName);

    if (cleanUpiId) {
      fd.append("upiId", cleanUpiId);
    }

    if (chequeFile) {
      fd.append("cheque", chequeFile);
    }

    if (qrCodeFile) {
      fd.append("qrCode", qrCodeFile);
    }

    try {
      setLoading(true);
      const res = await addSettlementAccount(fd);

      if (res?.success) {
        notify(res?.message || "Settlement Account Added Successfully", "success");
        resetForm();
        close();
      } else {
        notify(res?.message || "Failed to add account", "error");
      }
    } catch (err) {
      notify(
        err?.response?.data?.message || err?.message || "Server Error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-3">
      <div className="ds-card p-4 md:p-5 w-full max-w-[500px] max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">
            Add Settlement Account
          </h2>

          <button
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="text-[var(--text-muted)] hover:text-[var(--text-dark)] text-xl disabled:opacity-50"
          >
            ×
          </button>
        </div>

        <form className="space-y-3" onSubmit={handleSubmit}>
          {/* Account Holder + Bank */}
          <div>
            <label className="ds-label">
              Account Holder Name <span className="text-[var(--error-color)]">*</span>
            </label>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <input
                type="text"
                value={holderName}
                onChange={(e) => setHolderName(e.target.value)}
                className="ds-input text-sm"
                placeholder="Enter name"
                disabled={loading}
              />

              <select
                className="ds-input text-sm"
                value={bankId}
                onChange={handleBankChange}
                disabled={loading}
              >
                <option value="" disabled>
                  Select Bank Name
                </option>

                {allBanks.map((bank) => (
                  <option key={bank.BankId} value={bank.BankId}>
                    {bank.BankName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Account Number */}
          <div>
            <label className="ds-label">
              Account Number <span className="text-[var(--error-color)]">*</span>
            </label>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <input
                type="text"
                inputMode="numeric"
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value.replace(/\D/g, ""))}
                className="ds-input text-sm"
                placeholder="Account Number"
                disabled={loading}
              />

              <input
                type="text"
                inputMode="numeric"
                value={confirmAccount}
                onChange={(e) => setConfirmAccount(e.target.value.replace(/\D/g, ""))}
                className="ds-input text-sm"
                placeholder="Confirm Account Number"
                disabled={loading}
              />
            </div>
          </div>

          {/* IFSC + Bank Verification button (hamesha ek hi row me) */}
          <div>
            <label className="ds-label">
              IFSC Code <span className="text-[var(--error-color)]">*</span>
            </label>

            <div className="flex flex-row items-start gap-2">
              <input
                type="text"
                value={ifsc}
                maxLength={11}
                onChange={(e) => setIfsc(e.target.value.toUpperCase())}
                className="ds-input flex-1 min-w-0 text-sm uppercase"
                placeholder="IFSC Code (e.g. SBIN0001234)"
                disabled={loading}
              />

              {/* Reusable Bank Verification UI */}
              <BankVerificationBox
                verification={bankVerification}
                className="shrink-0 max-w-[45%]"
              />
            </div>
          </div>

          {/* Optional File */}
          <div>
            <label className="ds-label">
              Upload Cancel Cheque / Passbook <span className="text-[var(--text-muted)]">(Optional)</span>
            </label>

            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="ds-input text-sm"
              disabled={loading}
            />

            {chequeFile && (
              <p className="text-xs text-[var(--text-muted)] mt-1">
                Selected: {chequeFile.name}
              </p>
            )}
          </div>

          {/* Remarks + UPI */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="ds-label">
                Remarks <span className="text-[var(--text-muted)]">(Optional)</span>
              </label>

              <textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                className="ds-input text-sm h-20 resize-none"
                placeholder="Remarks"
                disabled={loading}
              />
            </div>

            <div>
              <label className="ds-label">
                UPI ID <span className="text-[var(--text-muted)]">(UPI or QR Code required)</span>
              </label>

              <input
                type="text"
                value={upiId}
                onChange={(e) => setUpiId(e.target.value.trimStart())}
                className="ds-input text-sm"
                placeholder="example@upi"
                disabled={loading}
              />
            </div>
          </div>

          <div>
            <label className="ds-label">
              QR Code <span className="text-[var(--text-muted)]">(Optional)</span>
            </label>
            <input
              type="file"
              accept="image/png,image/jpeg,image/webp"
              onChange={(event) => {
                const file = event.target.files?.[0] || null;
                if (file && file.size > 5 * 1024 * 1024) {
                  notify("QR Code image must be 5 MB or smaller", "error");
                  event.target.value = "";
                  return;
                }
                setQrCodeFile(file);
              }}
              className="ds-input text-sm"
              disabled={loading}
            />
            {qrCodeFile && (
              <p className="mt-1 text-xs text-[var(--text-muted)]">
                Selected: {qrCodeFile.name}
              </p>
            )}
          </div>

          {/* Actions */}
          <div className="ds-form-actions">
            <button
              type="submit"
              disabled={loading || (bankVerification.verificationRequired && !bankVerification.ready)}
              className="ds-btn ds-btn-primary"
            >
              {loading ? "Adding..." : "Add Settlement Account"}
            </button>

            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className="ds-btn ds-btn-secondary"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBank;